import { render, staticRenderFns } from "./configSettingsTable.vue?vue&type=template&id=486b689b"
import script from "./configSettingsTable.vue?vue&type=script&lang=js"
export * from "./configSettingsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports